import { render, staticRenderFns } from "./applygj.vue?vue&type=template&id=6118bb70&scoped=true"
import script from "./applygj.vue?vue&type=script&lang=js"
export * from "./applygj.vue?vue&type=script&lang=js"
import style0 from "./applygj.vue?vue&type=style&index=0&id=6118bb70&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6118bb70",
  null
  
)

export default component.exports